import React from "react";
import { Row } from "reactstrap";
import { ColCard } from "../../../components/ContentLayout";
import HomeTax from "./HomeTax";
import Crefia from "./Crefia";
import BankAccountMapping from "./BankAccountMapping";
import CardAccountMapping from "./CardAccountMapping";
import CashAccountMapping from "./CashAccountMapping";

const AutomaticSetting = ({ permission }) => {

  return (
    <div className="automatic-setting">
      <section id="section-one">
        <Row>
          <ColCard>
            <HomeTax permission={permission} />
          </ColCard>
          <ColCard>
            <Crefia permission={permission} />
          </ColCard>
        </Row>
      </section>
      <section id="section-two">
        <Row>
          <ColCard cardBody={{ className: "p-0" }}>
            <BankAccountMapping permission={permission} />
          </ColCard>
        </Row>
      </section>
      <section id="section-three">
        <Row>
          <ColCard cardBody={{ className: "p-0" }}>
            <CardAccountMapping permission={permission} />
          </ColCard>
        </Row>
      </section>
      <section id="section-four">
        <Row>
          <ColCard cardBody={{ className: "p-0" }}>
            <CashAccountMapping permission={permission} />
          </ColCard>
        </Row>
      </section>
    </div>
  );
};

export default AutomaticSetting;
